﻿import {Grid, GridOwnProps} from "@mui/material";
import {styled} from "@mui/material/styles";

type RevisedGridItemProps = GridOwnProps & {
  isSingleColumn?: boolean;
}

type RootType = RevisedGridItemProps;

const Root = styled(Grid, {
  shouldForwardProp: (prop) => prop !== 'isSingleColumn'
})(({ isSingleColumn }: RootType) => (isSingleColumn && {
  width: '35%',
  marginTop: '2em',
} || {
  display: 'none'
}));

const RevisedGridItem = (props: RevisedGridItemProps) => {
  return <Root item {...props} />
}

export default RevisedGridItem;
